import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";
import {ArrowBack, ArrowDownward, ArrowForward} from "@material-ui/icons";
import extratoPortaMoedasStyle from "../assets/jss/material-dashboard-pro-react/components/extratoPortaMoedasStyle";

function ExtratoPortaMoedas({...props}) {

  const {classes, stories, simple, standalone} = props;
  const timelineClass = classes.timeline + " " + cx({[classes.timelineSimple]: simple, [classes.timelineStandalone]: standalone,});

  return (
    <ul className={timelineClass}>
      {stories.map((prop, key) => {
        let icone = {
          credito: <ArrowForward/>,
          reembolso: <ArrowDownward/>,
          debito: <ArrowBack/>
        }[prop.estado]

        let cor = {
          credito: "primary",
          reembolso: "warning",
          debito: "danger"
        }[prop.estado]

        const panelClasses = classes.timelinePanel + " " + cx({[classes.timelinePanelInverted]: prop.inverted, [classes.timelineSimplePanel]: simple});
        const timelineBadgeClasses = classes.timelineBadge + " " + classes[cor] + " " + cx({[classes.timelineSimpleBadge]: simple});

        return (
          <li className={classes.item} key={key}>
            {icone ? (
              <div className={timelineBadgeClasses}>
                {icone}
              </div>
            ) : null}
            <>
              <div className={panelClasses} style={{maxWidth: "90%"}}>
                <span className={classes.timelineHeading}>{prop.designacao}</span> <span>{moment(prop.data).format("DD/MM/YYYY")}</span>
                <div style={{display: "flex", flexWrap: "wrap"}}>
                  <div style={{width: "40%"}}>
                    <table>
                      <thead>
                      <th style={{width: "15%"}}>Saldo Inicial</th>
                      <th style={{width: "15%"}}>Valor {prop.designacao}</th>
                      <th style={{width: "15%"}}>Saldo Final</th>
                      </thead>
                      <tr>
                        <td style={{width: "15%"}}>{prop.saldo_inicial.toFixed(2) + "€"}</td>
                        <td style={{width: "15%"}}>{prop.valor.toFixed(2) + "€"}</td>
                        <td style={{width: "15%"}}>{prop.saldo_final.toFixed(2) + "€"}</td>
                      </tr>
                    </table>
                  </div>
                  <div style={{maxWidth: "55%"}}>
                    <p><b>Descrição</b></p>
                    <div className={classes.description}>{prop.descricao}</div>
                  </div>
                </div>
              </div>
            </>
          </li>
        );
      })}
    </ul>
  );
}

ExtratoPortaMoedas.propTypes = {
  classes: PropTypes.object.isRequired,
  stories:
  PropTypes.arrayOf(PropTypes.object).isRequired,
  simple:
  PropTypes.bool,
  standalone:
  PropTypes.bool
};

export default withStyles(extratoPortaMoedasStyle)(ExtratoPortaMoedas);
